export default __webpack_public_path__ + "static/media/MobileRequired.d604f17f.png";